import React, { useEffect, useState } from "react";

import { Button, Col, Container, Row } from "react-bootstrap";
import "react-image-gallery/styles/css/image-gallery.css";

import BannerComponent from "../components/Banner.component";
import BlogComponent from "../components/Blog.component";
import DocumentComponent from "../components/Document.component";
import ErrorComponent from "../components/Error.component";
import LoaderComponent from "../components/Loader.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";
import apiService from "../services/api";

import type { IBlog, ILastKey } from "@/interfaces/IBlog";

const Blogs = () => {
  const { t } = i18n;
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [blogs, setBlogs] = useState<IBlog[]>([]);
  const [lastKey, setLastKey] = useState<ILastKey | undefined>(undefined);

  const fetchBlogs = async () => {
    try {
      const response = await apiService.fetchBlogs(6, lastKey);
      if (response.status === 200 && response.data?.blogs) {
        const blogsList = response.data.blogs as IBlog[];
        setBlogs((prevBlogs) => [...prevBlogs, ...blogsList]);

        if (response.data.last_key) {
          const lastEvalKey = response.data.last_key as ILastKey;
          setLastKey(lastEvalKey);
        } else {
          setLastKey(undefined);
        }
      }
    } catch (err: any) {
      if (err.response?.status && err.response.status === 404) {
        // not found
      } else {
        setError(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <DocumentComponent title={t("blog")} />

      {isLoading ? <LoaderComponent /> : null}

      {error ? <ErrorComponent /> : null}

      {!isLoading && !error && !blogs && "blogs not found"}

      {blogs && blogs.length > 0 ? (
        <React.Fragment>
          <BannerComponent
            description={t("blog_description")}
            title={t("blog")}
          />

          <Container className="mb-4 blogs-container">
            <Row>
              <Col className="mt-2 mb-3" lg={{ span: 10, offset: 1 }} xs={12}>
                <Row>
                  {blogs
                    .filter(
                      (blog) =>
                        "title" in blog && "date" in blog && "author" in blog,
                    )
                    .map((blog) => (
                      <Col
                        key={blog.id}
                        className="mb-4"
                        sm={{ span: 6, offset: 0 }}
                        xl={4}
                        xs={{ span: 10, offset: 1 }}
                      >
                        <BlogComponent blog={blog} />
                      </Col>
                    ))}

                  <Col className="text-center mt-4" xs={12}>
                    {lastKey && !isLoading ? (
                      <Button
                        className="btn-outline"
                        onClick={fetchBlogs}
                        size="sm"
                        variant="outline-success ps-4 pe-4 "
                      >
                        {t("load_more")}
                      </Button>
                    ) : null}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>

          <ScheduleComponent />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};

export default Blogs;
